import React from 'react';
import { useTranslation } from 'react-i18next';
import { gender } from '../../../../../enums/genderEnum';
import groupCheckCircle from '../../../../../assets/images/group-check-circle.svg';
import DividerWithText from '../../../../../components/DividerWithText';
import NotInformation from '../../../../../components/NotInformation';
import RowResumeText from '../../../../../components/RowResumeText';
import {EMPTY_VALUES, getDateFormat} from '../../../../../Apis/functions';
import AssignFreeCardTable from '../Table/AssignFreeCardTable';
import CustomTable from '../../../../../components/table/CustomTable';
import Step4AccessRights from './Step4AccessRights';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';

const Step8Summary = ({
    userData,
    onChange,
    extraData,
    headersList,
    employeeData,
    employeeRoles,
    contractStatusList,
    employeeWorkStations,
    employeeDepartments,
    workShiftsList,
    setWorkShiftsList,
    customizedList,
    setCustomizedList,
    extraDataEnabled,
    selectedImage,
    selfieSrc,
    fingerprintSrc,
    fingerprintName,
    cardDataInfo,
    photoPicker,
    isPilgrimsValidation
}) => {
    const { t } = useTranslation();

    const { tableId, thead, tbody } = AssignFreeCardTable({
        data: cardDataInfo,
        excludedId: [],
        setSelectedList: () => {},
    });
    return (
        <div className='row mt-4'>
            <DividerWithText title={t('details')} />
            <div className='grid-container-resume-data mb-2'>
                <RowResumeText title={t('name')} value={userData?.name} />
                <RowResumeText title={t('last_name')} value={userData?.lastName} />
                <RowResumeText title={t('second_last_name')} value={userData?.secondLastName || EMPTY_VALUES.DEFAULT} />
                <RowResumeText title={t('email')} value={userData?.email} />
                <RowResumeText title={t('gender')} value={t(gender[userData?.genderId])} />
                <RowResumeText
                    title={t('phone_number')}
                    value={userData?.phoneNumber ? '+' + userData?.phoneNumber : EMPTY_VALUES.DEFAULT}
                />
                <RowResumeText title={t('documentId')} value={userData?.documentId} />
                <RowResumeText title={t('dob')} value={getDateFormat(userData?.dob, false)} />
                <RowResumeText title={t('pin')} value={userData?.pin || EMPTY_VALUES.DEFAULT} />
            </div>

            {extraDataEnabled && (
                <>
                    <DividerWithText title={t('other_details')} />
                    <div className='grid-container-resume-data mb-2'>
                        {Array.from({ length: 15 }, (_, index) => (
                            <RowResumeText
                                key={index}
                                title={headersList[`header${index + 1}`] || `header_${index + 1}`}
                                value={extraData[`field${index + 1}`]}
                            />
                        ))}
                    </div>
                </>
            )}
            <DividerWithText title={t('employee_contract')} />
            <div className='grid-container-resume-data mb-2'>
                <RowResumeText
                    title={t('privilege')}
                    value={employeeRoles.find((item) => item.id === employeeData?.roleId)?.name || EMPTY_VALUES.DEFAULT}
                />
                <RowResumeText title={t('employee_id')} value={employeeData?.employeeId} />
                <RowResumeText title={t('ceco')} value={employeeData?.cecoCode || EMPTY_VALUES.DEFAULT} />
                <RowResumeText title={t('start_date')} value={getDateFormat(employeeData?.startDate, false)} />
                <RowResumeText title={t('end_date')} value={getDateFormat(employeeData?.endDate, false)} />
                <RowResumeText
                    title={t('work_station')}
                    value={employeeWorkStations.find((item) => item.id === employeeData?.zoneId)?.name || EMPTY_VALUES.DEFAULT}
                />
                <RowResumeText
                    title={t(isPilgrimsValidation ?  'work_group':'department' )}
                    value={employeeDepartments.find((item) => item.id === employeeData?.departmentId)?.name || EMPTY_VALUES.DEFAULT}
                />
            </div>

            <DividerWithText title={t('access_rights')} />
            <Step4AccessRights
                details={true}
                workShiftsList={workShiftsList}
                setWorkShiftsList={setWorkShiftsList}
                customizedList={customizedList}
                setCustomizedList={setCustomizedList}
                isEditable={false}
            />

            <DividerWithText title={t('take_photography')} />
            <PhotoPickerSummary
                photoPicker={photoPicker}
                classWith={'w-400px'}
            />

            <DividerWithText title={t('capture_fingerprint')} />
            {fingerprintSrc !== '' ? (
                <div className='mt-5 text-center d-flex flex-column justify-content-center'>
                    <img src={groupCheckCircle} className='thumb-image' alt='Thumb' />
                    <span className='mt-4'>{t('name')}</span>
                    <p className='mt-1'>{fingerprintName}</p>
                </div>
            ) : (
                <div className='my-2'>
                    <NotInformation text={t('no_information')} card={true} />
                </div>
            )}

            <DividerWithText title={t('card')} />
            <div className='col-12'>
                <CustomTable
                    tableId={tableId}
                    checkbox={false}
                    isAllChecked={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    withoutHeight={true}
                />
            </div>
        </div>
    );
};
export default Step8Summary;
